var __jsx = React.createElement;
import React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
const Poland = () => {
  return ___EmotionJSX("svg", {
    fill: "none",
    height: "15",
    viewBox: "0 0 20 15",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("mask", {
    height: "15",
    id: "mask0_305_22691",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("rect", {
    fill: "white",
    height: "15",
    width: "20"
  })), ___EmotionJSX("g", {
    mask: "url(#mask0_305_22691)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "#F7FCFF",
    fillRule: "evenodd"
  }), ___EmotionJSX("mask", {
    height: "15",
    id: "mask1_305_22691",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    },
    width: "20",
    x: "0",
    y: "0"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 0V15H20V0H0Z",
    fill: "white",
    fillRule: "evenodd"
  })), ___EmotionJSX("g", {
    mask: "url(#mask1_305_22691)"
  }, ___EmotionJSX("path", {
    clipRule: "evenodd",
    d: "M0 7.5V15H20V7.5H0Z",
    fill: "#C51918",
    fillRule: "evenodd"
  }))), ___EmotionJSX("rect", {
    height: "14",
    rx: "0.5",
    stroke: "#E8E7E4",
    width: "19",
    x: "0.5",
    y: "0.5"
  }));
};
export default Poland;
//# sourceMappingURL=Poland.js.map
// @zapier/checkout@7.9.7 (23abc9ace)
